import { FC, useEffect } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Skeleton } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';

import { useMeterReadingsFlow } from '../../../../state/MeterReadingsFlow.machine';
import { Steps } from '../../../../tracking';
import { Breakdown } from '../../../templates/Breakdown';

export const PeriodicPayBack: FC = () => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/PeriodicPayBack.${label}.${locale}.json`)}>
      <PeriodicPayBackComponent />
    </I18nProvider>
  );
};

export const PeriodicPayBackComponent: FC = () => {
  const { label } = useDC();
  const { t, isLoading } = useTranslation();
  const { trackFunnelCompleted } = useTracking();
  const { state } = useMeterReadingsFlow();

  useEffect(() => {
    trackFunnelCompleted({
      step: Steps['THANK_YOU.PeriodicPayBack'],
      funnel: state.context.funnelName,
    });
  }, [state.context.funnelName, trackFunnelCompleted]);

  if (isLoading) return <Skeleton height={450} />;

  return (
    <Breakdown
      title={t('periodicPayBack.title')}
      content={t('periodicPayBack.content')}
      buttonHref={t('periodicPayBack.buttonLink.href')}
      buttonText={t('periodicPayBack.buttonLink.text')}
      footerLabel={t('periodicPayBack.priceDetailsFooterLabel')}
      heroImage={{
        value: {
          src: `${getStaticPrefix()}/images/${label}/meterreadings/${t('periodicPayBack.imageSrc')}`,
        },
      }}
    />
  );
};
